import { forwardRef } from 'react';
import { Icon } from 'src/components/icon/Icon';
import { Chip, Stack, Typography } from 'src/components/mui';
import { useMenuContext } from '../../context';

type Props = {
  label: string;
  hasBeenOpened: boolean;
  bgColor?: string;
  textColor?: string;
};

export const Tooltip = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { rtl } = useMenuContext();
  const { label, hasBeenOpened, bgColor, textColor } = props;
  return (
    <Chip
      ref={ref}
      sx={{
        background: bgColor,
        height: '32px !important',
      }}
      label={
        <Stack direction={rtl ? 'row-reverse' : 'row'} spacing={1} alignItems="center">
          <Typography
            sx={{
              color: textColor,
            }}
          >
            {label}
          </Typography>
          <Icon
            sx={{
              ...(rtl && !hasBeenOpened
                ? {
                    marginLeft: '8px !important',
                    marginRight: '0px !important',
                  }
                : {}),
            }}
            type="fas"
            icon="fa-circle-arrow-right"
            style={{ color: textColor }}
          />
        </Stack>
      }
    />
  );
});
